import useFormatDate from 'hooks/useFormatDate'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { ActionButtons } from 'views/components/Table/Cells/ActionButtons'
import { BlackListUserBtn } from 'views/components/TaskActions/BlackListUserBtn'
import UserRoutes from 'views/pages/User/routes'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'
import { UseDashboardColumnsProps } from '../components/DashboardTasksList'

import { ColumnsType } from '@agro-club/agroclub-shared'
import { PHONE_TABLE_CELL_WIDTH } from 'modules/constants'
import { Task } from 'modules/domain/task/types'
import { CompleteTaskBtn } from 'views/components/TaskActions/CompleteTask/CompleteTaskBtn'
import APhone from 'views/ui/Phone/APhone'

export const useNewUserColumns = ({ refetch, successText }: UseDashboardColumnsProps): ColumnsType<any> => {
  const { t } = useTranslation()
  const formatDate = useFormatDate()

  return useMemo(
    () => [
      {
        title: t('newUsers:list.tableHeaders.date_joined'),
        width: 140,
        dataIndex: 'registration_date',
        render: (registration_date) => <>{formatDate(registration_date, { withTime: true })}</>,
      },
      {
        title: t('newUsers:list.tableHeaders.user'),
        dataIndex: 'linked_user',
        autoWidth: 352,
        render: (linked_user: Task['linked_user'], record) => {
          const { pathname, search } = window.location
          return (
            <TableTextLink
              id="user"
              tableItemId={record.linked_user.id}
              state={{ pathname, search }}
              to={generatePath(UserRoutes.Details, { id: record.linked_user.id })}
            >
              {linked_user?.full_name || linked_user?.phone}
            </TableTextLink>
          )
        },
      },
      {
        title: t('common:phone'),
        dataIndex: 'linked_user',
        width: PHONE_TABLE_CELL_WIDTH,
        render: ({ phone }) => <APhone phone={phone} shortBtnTitle />,
      },
      {
        title: t('newUsers:list.tableHeaders.user_type'),
        dataIndex: 'linked_user',
        key: 'user_type',
        width: 334,
        render: ({ profile_type }) => <>{t(`newUsers:list.profile_type.${profile_type}`)}</>,
      },
      {
        title: t('newUsers:list.tableHeaders.team'),
        width: 112,
        dataIndex: 'assigned_team',
        render: (assigned_team) => assigned_team && <>{assigned_team.name}</>,
      },
      {
        title: t('newUsers:list.tableHeaders.action'),
        width: 180,
        dataIndex: 'id',
        render: (id, task) => {
          return (
            <ActionButtons>
              <CompleteTaskBtn refetch={refetch} task={task} successText={successText} forDashboard />
              <BlackListUserBtn refetch={refetch} userId={task.linked_user.id} forDashboard />
            </ActionButtons>
          )
        },
      },
    ],
    [formatDate, refetch, successText, t],
  )
}
